export default {
  computed: {
    countPages() {
      return Math.ceil(this.total / this.count);
    },
    // page: {
    //   get() {
    //     return parseInt(this.$route.params.page)
    //   },
    //   set(newValue) {
    //   }
    // }
    page() {
      return parseInt(this.$route.params.page);
    }
  },
  mounted() {
    this.query = this.getQuery;
    this.loadData();
  },
  methods: {
    search() {
      this.changePage(1);
      this.setQuery(this.query);
    },
    sort(sortColumnName, sortDirection) {
      this.setSorting({ sortColumnName, sortDirection });
      this.changePage(1);
    },
    changePage(page) {
      if (this.page !== page) {
        this.$router.push({
          name: this.$route.name,
          params: { page },
        });
      }
      this.loadData();
    },
    loadData() {
      const params = {
        query: this.query,
        page: this.page,
        count: this.count,
      }
      if (this.sortDirection !== null) {
        params.sort_column_name = this.sortColumnName
        params.sort_direction = this.sortDirection === 'ascending' ? 1 : -1
      }
      if (this.showDeletedCameras !== null) {
        params.show_deleted_cameras = this.showDeletedCameras ? 1 : 0
      }
      return this.getList(params);
    },
  },
};
